import {
  hm5LimitedReleaseDetailConstants,
  createHM5LimitedReleaseDetailConstants,
  editHM5LimitedReleaseDetailConstants,
  addTargetHM5LimitedReleaseDetailConstants,
  removeTargetHM5LimitedReleaseDetailConstants,
  activateHM5LimitedReleaseDetailConstants,
  deactivateHM5LimitedReleaseDetailConstants,
  deleteHM5LimitedReleaseDetailConstants,
} from "../_redux-constants";
import { hm5LimitedReleasesDetailService } from "../../_services";
import { errorExtractor } from "../../_helpers";

function getHM5LimitedReleaseDetail(queryParams) {
  function getHM5LimitedReleaseDetailLoad() {
    return {
      type: hm5LimitedReleaseDetailConstants.HM5_LIMITED_RELEASE_DETAIL_LOADING,
    };
  }
  function getHM5LimitedReleaseDetailSuccess(data) {
    return {
      type: hm5LimitedReleaseDetailConstants.HM5_LIMITED_RELEASE_DETAIL_SUCCESS,
      data,
    };
  }
  function getHM5LimitedReleaseDetailFailure(error) {
    return {
      type: hm5LimitedReleaseDetailConstants.HM5_LIMITED_RELEASE_DETAIL_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(getHM5LimitedReleaseDetailLoad());
    return hm5LimitedReleasesDetailService
      .getHM5LimitedReleaseDetail(queryParams)
      .then(
        (data) => {
          dispatch(getHM5LimitedReleaseDetailSuccess(data));
        },
        (error) => {
          dispatch(getHM5LimitedReleaseDetailFailure(error?.toString()));
        }
      );
  };
}

function createHM5LimitedReleaseDetail(requestBody, queryParams) {
  function createHM5LimitedReleaseDetailLoad() {
    return {
      type: createHM5LimitedReleaseDetailConstants.CREATE_HM5_LIMITED_RELEASE_DETAIL_LOADING,
    };
  }
  function createHM5LimitedReleaseDetailSuccess(data) {
    return {
      type: createHM5LimitedReleaseDetailConstants.CREATE_HM5_LIMITED_RELEASE_DETAIL_SUCCESS,
      data,
    };
  }
  function createHM5LimitedReleaseDetailFailure(error) {
    return {
      type: createHM5LimitedReleaseDetailConstants.CREATE_HM5_LIMITED_RELEASE_DETAIL_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(createHM5LimitedReleaseDetailLoad());
    return new Promise((resolve, reject) => {
      hm5LimitedReleasesDetailService
        .createHM5LimitedReleaseDetail(requestBody, queryParams)
        .then(
          (data) => {
            dispatch(createHM5LimitedReleaseDetailSuccess(data));
            resolve(data);
          },
          (error) => {
            dispatch(createHM5LimitedReleaseDetailFailure(error?.toString()));
            errorExtractor(error, reject);
          }
        );
    });
  };
}

function editHM5LimitedReleaseDetail(requestBody, queryParams) {
  function editHM5LimitedReleaseDetailLoad() {
    return {
      type: editHM5LimitedReleaseDetailConstants.EDIT_HM5_LIMITED_RELEASE_DETAIL_LOADING,
    };
  }
  function editHM5LimitedReleaseDetailSuccess(data) {
    return {
      type: editHM5LimitedReleaseDetailConstants.EDIT_HM5_LIMITED_RELEASE_DETAIL_SUCCESS,
      data,
    };
  }
  function editHM5LimitedReleaseDetailFailure(error) {
    return {
      type: editHM5LimitedReleaseDetailConstants.EDIT_HM5_LIMITED_RELEASE_DETAIL_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(editHM5LimitedReleaseDetailLoad());
    return new Promise((resolve, reject) => {
      hm5LimitedReleasesDetailService
        .editHM5LimitedReleaseDetail(requestBody, queryParams)
        .then(
          (data) => {
            dispatch(editHM5LimitedReleaseDetailSuccess(data));
            resolve(data);
          },
          (error) => {
            dispatch(editHM5LimitedReleaseDetailFailure(error?.toString()));
            errorExtractor(error, reject);
          }
        );
    });
  };
}

function addTargetHM5LimitedReleaseDetail(requestBody, queryParams) {
  function addTargetHM5LimitedReleaseDetailLoad() {
    return {
      type: addTargetHM5LimitedReleaseDetailConstants.ADD_TARGET_HM5_LIMITED_RELEASE_DETAIL_LOADING,
    };
  }
  function addTargetHM5LimitedReleaseDetailSuccess(data) {
    return {
      type: addTargetHM5LimitedReleaseDetailConstants.ADD_TARGET_HM5_LIMITED_RELEASE_DETAIL_SUCCESS,
      data,
    };
  }
  function addTargetHM5LimitedReleaseDetailFailure(error) {
    return {
      type: addTargetHM5LimitedReleaseDetailConstants.ADD_TARGET_HM5_LIMITED_RELEASE_DETAIL_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(addTargetHM5LimitedReleaseDetailLoad());
    return new Promise((resolve, reject) => {
      hm5LimitedReleasesDetailService
        .addTargetHM5LimitedReleaseDetail(requestBody, queryParams)
        .then(
          (data) => {
            dispatch(addTargetHM5LimitedReleaseDetailSuccess(data));
            resolve(data);
          },
          (error) => {
            dispatch(
              addTargetHM5LimitedReleaseDetailFailure(error?.toString())
            );
            errorExtractor(error, reject);
          }
        );
    });
  };
}

function removeTargetHM5LimitedReleaseDetail(queryParams) {
  function removeTargetHM5LimitedReleaseDetailLoad() {
    return {
      type: removeTargetHM5LimitedReleaseDetailConstants.REMOVE_TARGET_HM5_LIMITED_RELEASE_DETAIL_LOADING,
    };
  }
  function removeTargetHM5LimitedReleaseDetailSuccess(data) {
    return {
      type: removeTargetHM5LimitedReleaseDetailConstants.REMOVE_TARGET_HM5_LIMITED_RELEASE_DETAIL_SUCCESS,
      data,
    };
  }
  function removeTargetHM5LimitedReleaseDetailFailure(error) {
    return {
      type: removeTargetHM5LimitedReleaseDetailConstants.REMOVE_TARGET_HM5_LIMITED_RELEASE_DETAIL_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(removeTargetHM5LimitedReleaseDetailLoad());
    return new Promise((resolve, reject) => {
      hm5LimitedReleasesDetailService
        .removeTargetHM5LimitedReleaseDetail(queryParams)
        .then(
          (data) => {
            dispatch(removeTargetHM5LimitedReleaseDetailSuccess(data));
            resolve(data);
          },
          (error) => {
            dispatch(
              removeTargetHM5LimitedReleaseDetailFailure(error?.toString())
            );
            errorExtractor(error, reject);
          }
        );
    });
  };
}

function activateHM5LimitedReleaseDetail(queryParams) {
  function activateHM5LimitedReleaseDetailLoad() {
    return {
      type: activateHM5LimitedReleaseDetailConstants.ACTIVATE_HM5_LIMITED_RELEASE_DETAIL_LOADING,
    };
  }
  function activateHM5LimitedReleaseDetailSuccess(data) {
    return {
      type: activateHM5LimitedReleaseDetailConstants.ACTIVATE_HM5_LIMITED_RELEASE_DETAIL_SUCCESS,
      data,
    };
  }
  function activateHM5LimitedReleaseDetailFailure(error) {
    return {
      type: activateHM5LimitedReleaseDetailConstants.ACTIVATE_HM5_LIMITED_RELEASE_DETAIL_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(activateHM5LimitedReleaseDetailLoad());
    return new Promise((resolve, reject) => {
      hm5LimitedReleasesDetailService
        .activateHM5LimitedReleaseDetail(queryParams)
        .then(
          (data) => {
            dispatch(activateHM5LimitedReleaseDetailSuccess(data));
            resolve(data);
          },
          (error) => {
            dispatch(activateHM5LimitedReleaseDetailFailure(error?.toString()));
            reject(error);
          }
        );
    });
  };
}

function deactivateHM5LimitedReleaseDetail(queryParams) {
  function deactivateHM5LimitedReleaseDetailLoad() {
    return {
      type: deactivateHM5LimitedReleaseDetailConstants.DEACTIVATE_HM5_LIMITED_RELEASE_DETAIL_LOADING,
    };
  }
  function deactivateHM5LimitedReleaseDetailSuccess(data) {
    return {
      type: deactivateHM5LimitedReleaseDetailConstants.DEACTIVATE_HM5_LIMITED_RELEASE_DETAIL_SUCCESS,
      data,
    };
  }
  function deactivateHM5LimitedReleaseDetailFailure(error) {
    return {
      type: deactivateHM5LimitedReleaseDetailConstants.DEACTIVATE_HM5_LIMITED_RELEASE_DETAIL_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(deactivateHM5LimitedReleaseDetailLoad());
    return new Promise((resolve, reject) => {
      hm5LimitedReleasesDetailService
        .deactivateHM5LimitedReleaseDetail(queryParams)
        .then(
          (data) => {
            dispatch(deactivateHM5LimitedReleaseDetailSuccess(data));
            resolve(data);
          },
          (error) => {
            dispatch(
              deactivateHM5LimitedReleaseDetailFailure(error?.toString())
            );
            errorExtractor(error, reject);
          }
        );
    });
  };
}

function deleteHM5LimitedReleaseDetail(queryParams) {
  function deleteHM5LimitedReleaseDetailLoad() {
    return {
      type: deleteHM5LimitedReleaseDetailConstants.DELETE_HM5_LIMITED_RELEASE_DETAIL_LOADING,
    };
  }
  function deleteHM5LimitedReleaseDetailSuccess(data) {
    return {
      type: deleteHM5LimitedReleaseDetailConstants.DELETE_HM5_LIMITED_RELEASE_DETAIL_SUCCESS,
      data,
    };
  }
  function deleteHM5LimitedReleaseDetailFailure(error) {
    return {
      type: deleteHM5LimitedReleaseDetailConstants.DELETE_HM5_LIMITED_RELEASE_DETAIL_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(deleteHM5LimitedReleaseDetailLoad());
    return new Promise((resolve, reject) => {
      hm5LimitedReleasesDetailService
        .deleteHM5LimitedReleaseDetail(queryParams)
        .then(
          (data) => {
            dispatch(deleteHM5LimitedReleaseDetailSuccess(data));
            resolve(data);
          },
          (error) => {
            dispatch(deleteHM5LimitedReleaseDetailFailure(error?.toString()));
            errorExtractor(error, reject);
          }
        );
    });
  };
}

export const hm5LimitedReleasesDetailActions = {
  getHM5LimitedReleaseDetail,
  createHM5LimitedReleaseDetail,
  editHM5LimitedReleaseDetail,
  addTargetHM5LimitedReleaseDetail,
  removeTargetHM5LimitedReleaseDetail,
  activateHM5LimitedReleaseDetail,
  deactivateHM5LimitedReleaseDetail,
  deleteHM5LimitedReleaseDetail,
};
